
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class PetsDialog extends Serenity.EntityDialog<PetsRow, any> {
        protected getFormKey() { return PetsForm.formKey; }
        protected getIdProperty() { return PetsRow.idProperty; }
        protected getLocalTextPrefix() { return PetsRow.localTextPrefix; }
        protected getNameProperty() { return PetsRow.nameProperty; }
        protected getService() { return PetsService.baseUrl; }
        protected getDeletePermission() { return PetsRow.deletePermission; }
        protected getInsertPermission() { return PetsRow.insertPermission; }
        protected getUpdatePermission() { return PetsRow.updatePermission; }

        protected form = new PetsForm(this.idPrefix);

    }
}